import { useDispatch } from 'react-redux';
import { $actions } from 'Store/ducks';
import { useAsyncAction } from 'Hooks/Common';
import { UnfreezeTeamMembersPayload } from 'Interfaces/Team';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: UnfreezeTeamMembersPayload) =>
    $actions.team.unfreezeTeamMembers(dispatch, payload),
  );
};
